import { PlatformInterface } from './interfaces';

export const platformInitialState: PlatformInterface = {
  /* TODO: remove this slice of state, this data is no longer used by application */
  emissionsAverted: 0,
  totalSolarFunded: 0,
  projectsFunded: 0,
  returnsGenerated: 0,
};
